import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import {
  stopShufflingWordsState,
  stopRemoveSpecialCharactersState,
  stopRemoveStopwordsState,
} from '~/store/atoms/main';

export default function StopShuffleWords() {
  const { t } = useTranslation();
  const [stopShufflingWords, setStopShufflingWords] = useRecoilState(stopShufflingWordsState);
  const [stopRemoveSpecialCharacters, setStopRemoveSpecialCharacters] = useRecoilState(
    stopRemoveSpecialCharactersState
  );
  const [stopRemoveStopwords, setStopRemoveStopwords] = useRecoilState(stopRemoveStopwordsState);

  return (
    <Box>
      <Typography>{t('Select the option to apply when shuffle words:')}</Typography>
      <FormControlLabel
        control={<Checkbox checked={stopShufflingWords} onChange={(e, newValue) => setStopShufflingWords(newValue)} />}
        label={t('Stop Shuffling Words.')}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={stopRemoveSpecialCharacters}
            onChange={(e, newValue) => setStopRemoveSpecialCharacters(newValue)}
          />
        }
        label={t('Stop remove special characters.')}
      />
      <FormControlLabel
        control={
          <Checkbox checked={stopRemoveStopwords} onChange={(e, newValue) => setStopRemoveStopwords(newValue)} />
        }
        label={t('Stop remove stopwords.')}
      />
    </Box>
  );
}
